import { PixelPlaceholderLoaderStyled } from "../../StyledComponents";

export const SerpTilesLoader = ({
    loaderCount,
    height,
    width,
}: {
    loaderCount: number;
    height: number;
    width: number;
}) => {
    const loaders = Array.from({ length: loaderCount }, (_, index) => (
        <PixelPlaceholderLoaderStyled
            key={index}
            width={width}
            height={height}
        />
    ));

    return <div style={{ display: "flex" }}>{loaders}</div>;
};
